module.exports = __webpack_public_path__ + "static/media/master_black.84435054.png";